// extracted by mini-css-extract-plugin
module.exports = {"submitButtonWrapper":"SubmitButton_submitButtonWrapper__sw3f_","packDetail":"SubmitButton_packDetail__heWtD","submitButton":"SubmitButton_submitButton__sQUB5"};